import {
    GET_CHAT_MESSAGES_SUBMITTING,
    GET_CHAT_MESSAGES_SUCCESS,
    CLEAR_CHAT_MESSAGE_COUNT,
    SEND_CHAT_MESSAGE_SUBMITTING,
    CLEAR_CHAT_MESSAGES
} from 'Constants/actionConstants';

const chat = (state={
    messages: [],
    fetchingMessages: false,
    newMessagesCount: 0
}, action)=> {
    let newState;
    if(action.type === SEND_CHAT_MESSAGE_SUBMITTING) {
        newState = {...state};
        newState.messages = [...newState.messages, action.newMessage];
    } else if(action.type === GET_CHAT_MESSAGES_SUBMITTING) {
        newState = {...state};
        newState.fetchingMessages = true;
    } else if(action.type === GET_CHAT_MESSAGES_SUCCESS) {
        newState = {...state};
        const msgsFiltered = newState.messages.filter((msg) => msg.id != 'TMP_MSG');
        if(action.previousMessages) {
            newState.messages = [...action.messages.reverse(), ...msgsFiltered]
        } else {
            newState.messages = [...msgsFiltered, ...action.messages.reverse() ];
        }
        newState.newMessagesCount = action.count;
        newState.fetchingMessages = false;
    } else if(action.type === CLEAR_CHAT_MESSAGE_COUNT) {
        newState = {...state};
        // newState.newMessagesCount = 0;
    } else if(action.type === CLEAR_CHAT_MESSAGES) {
        newState = {...state};
        newState.newMessagesCount = 0;
        newState.messages = [];
    }
    return newState || state;
}

export default chat;